import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import { FaSpinner } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'

export default function Login({saveUserData, isLogged, setIsLogged}) {

  console.log(isLogged);

  const [user, setUser] = useState({
    email: '',
    password: ''
  })

  const [status, setStatus] = useState('')

  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)

  function handleChange(e){
    let myUser = {...user}
    setUser({
      ...myUser,
      [e.target.name]: e.target.value
    })
  }

  async function sendData(){
    let { data} = await Axios.get(`http://localhost:8000/users`)
    var userData ;
    // if the email does exist, store the user data in userData
    data.forEach(element => {
      if(element.email === user.email){
        userData = element
      }
    });
    // if the userData is defined, check if the password is correct, if it is, navigate to home, if not, show an Status message
    if(userData){
      if(userData.password === user.password){
        setIsLoading(false)
        console.log(userData);
        localStorage.setItem('user', JSON.stringify(userData))
        saveUserData()
        setIsLogged(true)
        navigate('/')
      }else{
        setIsLoading(false)
        setStatus('Password is incorrect')
      }
    }
    // if the userData is not defined, show an Status message
    else{
      setStatus('Email does not exist')
    }
  }

  function loginUser(e){
    e.preventDefault()
    sendData()
  }

  return (
    <div className='d-flex w-50 h-100 m-auto flex-column'>
      {/* the paragraph that show status */}
      {status.length>0? <div className='alert alert-danger my-2'>{status}</div>:null}
      <form className='m-2 w-100' onSubmit={loginUser}>
      <label htmlFor="email">Email</label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="email" id="email" name="email" />
      <label htmlFor="password">Password</label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="password" id="password" name="password" />
      <button className='btn btn-info' type="submit">
        {isLoading? <FaSpinner/> : 'Login'}
      </button>
    </form>
    </div>
  )
}